import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AsientosContables from './AsientosContables.jsx';
import * as actions from '../actions/Actions.js';

const mapStateToProps = (state) => {
    return {
        data: state.asientosContables,
        tarjetas: state.tarjetas
    }
}

const mapDispatchToProps = (dispatch) => { return { actions: bindActionCreators(actions, dispatch) } }

const AsientosContablesContainer = connect(mapStateToProps, mapDispatchToProps)(AsientosContables);


export default AsientosContablesContainer;